var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoncertLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "koncert-logo_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCA103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD3602"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "koncert-logo_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCA103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD3602"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "koncert-logo_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FD3602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCA103"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "koncert-logo_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCA103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD3602"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#koncert-logo_svg__a)",
    d: "M0 0h8v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#koncert-logo_svg__b)",
    d: "M0 19l8-8v21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#koncert-logo_svg__c)",
    d: "M8 11L19 0h10L8 21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#koncert-logo_svg__d)",
    d: "M8 22l11-11h10L8 32z",
    transform: "matrix(1 0 0 -1 0 43)"
  }))));
}
export default __webpack_public_path__ + "img/016820c6deac07af674b2287f15eeb5e.svg";
export { SvgKoncertLogo as ReactComponent };